import { Button, Form, message } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { useForm } from "antd/es/form/Form";
import { useAuth } from "context/AuthContextProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PATHS from "shared/constants/paths";
import { translate } from "shared/languages";
import { AuthCard, AuthHeading, AuthSub, FieldLabel } from "./AuthUi";
import PhoneInput, { phoneRules } from "shared/components/PhoneInput";
import { textPx } from "shared/constants/zoom";

/** Forget password — centered card (prototype style); logic unchanged. */
const ForgetPassword = () => {
  const [form] = useForm();
  const navigate = useNavigate();
  const { recaptchaVerifier } = useAuth();
  const [sending, setSending] = useState(false);

  // Remove existing session storage:
  useEffect(() => {
    sessionStorage.removeItem("reset_number");
    sessionStorage.removeItem("verify_number");
  }, []);

  const onFinish = async () => {
    if (sending) return;
    setSending(true);
    try {
      const values = await form.validateFields();
      await recaptchaVerifier(values.phone_number);
      sessionStorage.setItem("reset_number", values.phone_number);
      navigate(PATHS.VERIFICATION);
    } catch (err) {
      console.error("Phone verification failed", (err as any)?.code, err);
      message.error(translate("messages.error.general"));
    } finally {
      setSending(false);
    }
  };

  return (
    <AuthCard onBack={() => navigate(PATHS.LOGIN)}>
      <AuthHeading>{translate("title.forget_password")}</AuthHeading>
      <AuthSub>{translate("subtitle.forget_password")}</AuthSub>

      <Form form={form} name="forget-password" layout="vertical" requiredMark={false} onFinish={onFinish} autoComplete="off">
        <Form.Item
          name="phone_number"
          label={<FieldLabel>{translate("label.phone_number")}</FieldLabel>}
          rules={phoneRules({ smsOtp: true })}
        >
          <PhoneInput variant="inline" smsOtp placeholder="812 345 6789" />
        </Form.Item>
        <div id="recaptcha-container" />
        <Form.Item style={{ marginTop: 20, marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" loading={sending} style={{ width: "100%" }}>
            {translate("button.send_otp")} <ArrowRightOutlined style={{ fontSize: textPx(14) }} />
          </Button>
        </Form.Item>
      </Form>
    </AuthCard>
  );
};

export default ForgetPassword;
